<template>
  <header class="fixed inset-x-0 top-0 z-[60] border-b border-slate-200/80 bg-white/80 backdrop-blur dark:border-white/10 dark:bg-slate-950/75">
    <div class="mx-auto flex h-16 max-w-5xl items-center justify-between px-4 sm:px-6 lg:px-8">
      <div class="flex min-w-0 items-center gap-4">
        <a href="/" aria-label="Homepage" class="shrink-0">
          <img src="https://t.rightmessage.com/logo.svg" alt="RightMessage" class="h-7 w-auto" />
        </a>
        <div class="h-6 w-px shrink-0 bg-slate-300/80 dark:bg-white/10" />
        <div class="min-w-0 text-sm font-medium text-brand-headline dark:text-white">
          <div v-if="teams.length > 1" class="w-32 min-w-0 sm:w-56">
            <TeamDropdown size="small" :selected-label="currentTeamBusinessName" />
          </div>
          <div v-else class="truncate">
            {{ currentTeamHeaderLabel }}
          </div>
        </div>
      </div>

      <a href="/logout" class="shrink-0 text-sm font-medium text-brand-link transition hover:text-brand-link/80">
        Sign out
      </a>
    </div>
  </header>
</template>

<script setup lang="ts">
import TeamDropdown from '@/components/common/TeamDropdown.vue'
import { useConfigStore } from '@/stores/configStore'

const configStore = useConfigStore()
const { currentTeam } = storeToRefs(configStore)

const teamStore = useTeamStore()
const { teams } = storeToRefs(teamStore)

const readNonEmptyString = (value: unknown): string | null => {
  if (typeof value !== 'string') return null

  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : null
}

const currentTeamBusinessName = computed(() => {
  const aiContext = currentTeam.value?.ai_context
  if (!aiContext || typeof aiContext !== 'object' || Array.isArray(aiContext)) return null

  return readNonEmptyString((aiContext as Record<string, unknown>).businessName)
})

const currentTeamHeaderLabel = computed(
  () => currentTeamBusinessName.value ?? readNonEmptyString(currentTeam.value?.name) ?? 'Your project'
)
</script>
